import { MeRepository } from 'common/repositories/index';

angular.module('directives')

    .directive('countrySelector', ($focus, Countries) => ({
        template: require('../../views/country-selector.html'),
        restrict: 'EA',
        replace: true,
        scope: {
            selectedDevice: '=',
            next: '&',
            inputError: '=',
        },
        compile: () => ({
            pre: (scope) => {

                let phone;
                scope.countries = [];

                angular.copy(Countries, scope.countries);
                scope.hasPrefix = false;

                if (!scope.selectedDevice) {

                    scope.selectedDevice = {};

                }
                scope.dialCode = {};

                const User = MeRepository.getMyUser();

                if (User.attributes.phone) {

                    phone = User.attributes.phone.split('/');

                }

                _.each(Countries, (country) => {

                    scope.dialCode[country.dialCode.substring(1)] = country;

                    // check countryCode for input field
                    if (country.code === User.attributes.country.toLowerCase() &&
                                !scope.selectedDevice.country) {

                        scope.selectedDevice.country = country;

                    }

                    // check phone & dialCode for input field
                    if (
                        (phone && phone[0].indexOf(country.dialCode) === 0) &&
                        // countries that have NO space (Ex: +40 RO ) and are not US or CA
                        (
                            (phone[0].charAt(2) !== ' ' && country.dialCode !== '+1') ||
                            // countries that have space (Ex: +1 393 PR ) and are not US or CA
                            (phone[0].charAt(2) === ' ' && country.dialCode !== '+1') ||
                            // +1 countries that are US or CA and are not ( +1268 AG or +1664 MS )
                            (
                                (phone[0].charAt(2) !== ' ' && country.dialCode === '+1') &&
                                (phone[0].indexOf('+1268') === -1 && phone[0].indexOf('+1664') === -1)
                            )
                        )
                    ) {

                        scope.selectedDevice.country = country;

                        // fix for numbers that contain a slash e.g +49/33242....
                        if (phone[0] === country.dialCode) {

                            scope.selectedDevice.phoneNumber = phone[1] || '';

                        } else {

                            scope.selectedDevice.phoneNumber = phone[0].replace(country.dialCode, '');

                        }

                    }

                });

            },
            post: (scope, element) => {

                /* listen for ENTER key pressed */
                element.bind('keydown', (event) => {

                    const key = event.keyCode || event.which;
                    const keyCodesMappings = {
                        ENTER: 13,
                    };
                    if (key === keyCodesMappings.ENTER) {

                        scope.next();

                    }

                });

                scope.$watch('selectedDevice.phoneNumber', (phoneNumber) => {

                    let foundPrefix = false;
                    let prefix = '';
                    const startIdx = 0;
                    let idx = 1;

                    if (!phoneNumber) {

                        return;

                    }

                    if (((startIdx === 1) && phoneNumber.charAt(0) === '+') ||
                                ((startIdx === 2) && phoneNumber.substring(0, 2) === '00')) {

                        idx = startIdx + 1;
                        while (!foundPrefix && idx <= phoneNumber.length) {

                            prefix = phoneNumber.substring(startIdx, idx);
                            if (scope.dialCode[prefix]) {

                                foundPrefix = true;
                                scope.hasPrefix = true;
                                scope.selectedDevice.country = scope.dialCode[prefix];

                            }
                            idx += 1;

                        }

                    }
                    if (!foundPrefix) {

                        scope.hasPrefix = false;

                    }

                });

                scope.$watch('selectedDevice.country.name', (newValue, oldValue) => {

                    if (!angular.isUndefined(newValue) && !angular.isUndefined(oldValue) &&
                                (newValue !== oldValue)) {

                        scope.hasPrefix = false;

                    }
                    $focus(scope, 'phoneNumber');

                });

                scope.hideError = () => {

                    if (scope.inputError) {

                        scope.inputError = false;

                    }

                };

            },
        }),
    }));

angular.module('filters')
    .filter('filterCountry', () => (countries, query) => {

        if (angular.isUndefined(query) || !query) {

            return countries;

        }
        return _.filter(countries, (country) => {

            const dialCode = country.dialCode || '';
            if (!country.name) {

                return false;

            }
            return (country.name.toLowerCase().indexOf(query.toLowerCase()) === 0 ||
                dialCode.indexOf(query) >= 0);

        });

    });



// WEBPACK FOOTER //
// ./scripts/directives/country-selector.js